import { tr } from "date-fns/locale";

export class Constants {
  // serverURL = "https://busivr.mokalmat.com:443/api/";
  // serverURL = "https://vbp.mokalmat.com:1443/api/";
  // serverURL="https://41.206.128.129:443/api/";

  serverURL = this.getServerURL();

  TESTING = process.env.REACT_APP_ENV === 'dev' || process.env.REACT_APP_ENV === 'local';


    getServerURL() {
    const env = process.env.REACT_APP_ENV;
    
    switch(env) {
      case 'prod':
        return "https://010hotline.vodafone.com.eg:443/api/";
      case 'dev': 
        return "https://cloud-dev.edafa.com:1443/api/";
      case 'test':
        return "https://172.28.38.72:443/api/";
      default:
        return "http://localhost:8092/api/"; // fallback for local development
    }
  }
  cdrAudioPath = this.serverURL + "static/audio/";

  MASTER_ACC_ID = "MASTER";

  enableCallRecordExpiration = true; // flag to enable or disable the call record expiration feature
  enableVoiceMailExpiration = false; // flag to enable or disable the voicemail expiration feature


  response_success_auth_failed = -1;
  successCode = 0;
  invalid_session = 2;
  DATE_FMT = "yyyy-MM-dd";
  DATE_TIME_FMT = `${this.DATE_FMT} hh:mm:ss`;
  PREFIX_NUM = "010";
  deletedStatus = "DEL";
  MAX_WAV_SIZE = 10000000;
  MAX_MPEG_SIZE = 4000000;

  enableCallRecordExpiration = true; // flag to enable or disable the call record expiration feature
  enableVoiceMailExpiration = false; // flag to enable or disable the voicemail expiration feature
  navigateToInvitations = true;


  StatusList = {
    Initial: "INT",
    Active: "ACT",
    Suspended: "SUS",
    Deleted: "DEL",
  };

  cfgCategoryList = {
    CFG_GROUP_CALLFLOW_CATEGORY: "CALL_FLOW",
    CFG_GROUP_SWITCHINGCATEGORY: "SWITCHING",
  };

  cfgKeyList = {
    CFG_GROUP_CALLFLOW_KEY: "CALL_FLOW",
    CFG_GROUP_SWITCHING_KEY: "SWITCH_MODE",
  };

  validationPatterns = {
    email: "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-z]{2,4}$",
    phone: "^[0-9]+$",
  };

  groupTypeList = [
    "Inbound",
    //"Outbound",
    "Agent",
    "Back Office",
    // "Account",
  ];

  groupTypeList = {
    IBG: "IBG",
    SXG: "SXG",
    ADM: "ADM",
    Deleted: "DEL",
  };

  groupTypeDBList = ["IBG", "SXG", "ADM"];

  getGroupTypeDBValue(selectedVal) {
    if (selectedVal === this.groupTypeList[0]) return this.groupTypeDBList[0];
    if (selectedVal === this.groupTypeList[1]) return this.groupTypeDBList[1];
    if (selectedVal === this.groupTypeList[2]) return this.groupTypeDBList[2];
    //if (selectedVal === this.groupTypeList[3])
    //  return this.groupTypeDBList[3];
  }

  getGroupTypeStringValue(dbVal) {
    if (dbVal === this.groupTypeDBList[0]) return this.groupTypeList[0];
    if (dbVal === this.groupTypeDBList[1]) return this.groupTypeList[1];
    if (dbVal === this.groupTypeDBList[2]) return this.groupTypeList[2];
    if (dbVal === this.groupTypeDBList[3]) return this.groupTypeList[3];
  }

  switchingList = ["Round Robin", "Least Received Calls", "Most Idle Time"];

  getswitchingListDBValue(selectedVal) {
    return "" + this.switchingList.findIndex((index) => index === selectedVal);
  }

  userTypeList = {
    agent: "AGENT",
    admin: "ADMIN",
    super: "SUPER",
    customerCare: "CARE",
  };

  getTypeDBValue(selectedType) {
    return selectedType.toUpperCase();
  }

  genderList = ["Male", "Female"];

  getGenderValue(selectedGender) {
    if (selectedGender === this.genderList[0]) return "M";
    if (selectedGender === this.genderList[1]) return "F";
  }

  getGenderFullString(selectedGender) {
    if (selectedGender === "M") return "Male";
    if (selectedGender === "F") return "Female";
  }

  StatusListStrings = [
    this.StatusList.Intial,
    this.StatusList.Active,
    this.StatusList.Suspended,
  ];

  cdrServicesURLs = {
    getAccountCdrs: this.serverURL + "cdr/byAccountId",
    getHistoryCdrs: this.serverURL + "cdr/history",
    getAllCdrs: this.serverURL + "cdr/history/true",
    getCdrsFromToStartDate: this.serverURL + "cdr/",
  };

  cdrSwitchedServicesURLs = {
    getSwitchesForCDR: this.serverURL + "cdr/switch/",
    getSelectedSwitchesForCDRs: this.serverURL + "cdr/switch/selectedByIds",
  };
  accountServicesURLs = {
    getAccounts: this.serverURL + "account/",
    postAccount: this.serverURL + "account",
    editAccount: this.serverURL + "account",
    upgradeOrdowngradeAccount: this.serverURL + "account/changeAccountPackage",
    postAccountAdmin: this.serverURL + "v1/user/admin",
    getAllAccountMSISDN: this.serverURL + "account/listAccountMSISDN",
    addAccountMSISDN: this.serverURL + "account/addAccountMSISDN",
    deleteAccountMSISDN: this.serverURL + "account/deleteAccountMSISDN",
    getAdminDashboardData: this.serverURL + "v1/dashboard/adminData",
    getAdminBarsData: this.serverURL + "v1/dashboard/adminBarsData",
    getAdminLineGraphsData: this.serverURL + "v1/dashboard/adminLineGraphsData",
    getAgentData: this.serverURL + "v1/dashboard/agentData",
    getAgentGraphsData: this.serverURL + "v1/dashboard/agentGraphsData",
    viewListAccountMSISDN: this.serverURL + "account/ListAccountMSISDN",
    manageAccountNumbers: this.serverURL + "account/ManageAccountNumbers",
    deleteAccountNumber: this.serverURL + "account/deleteAccountNumber",
    AddBIVRNumbers: this.serverURL + "account/AddBIVRNumbers",
    deleteBIVRNumber: this.serverURL + "account/deleteBIVRNumber",
    postSuperUsers: this.serverURL + "v1/user/createSuperUsers",
  };

  invitationServicesURLs = {
    getCSRFToken: this.serverURL + "v1/csrf-token",
    getInvitationByToken: this.serverURL + "v1/invitations/getData",
    cancelInvitation: this.serverURL + "v1/invitations/cancel",
    resendInvitation:this.serverURL+"v1/invitations/resend",
    getPaginatedInvitationsByAccount:this.serverURL + "v1/invitations/byAccount",
    accpetInvitation: this.serverURL + "v1/invitations/accept",
    rejectInvitation: this.serverURL + "v1/invitations/reject",
  }

  cfgAccountServicesURLs = {
    getCfgAccounts: this.serverURL + "v1/cfgAccount/",
    editCfgAccount: this.serverURL + "v1/cfgAccount/",
    getCurrentConcurrentCalls:
      this.serverURL + "v1/cfgAccount/getCurrentConcurrentCalls/groupId/",
    getCfgsAccount: this.serverURL + "v1/cfgAccount/getCfgsAccount",
    getCFGAccount: this.serverURL + "v1/cfgAccount/accountId",
  };
  cfgGroupServicesURLs = {
    getCfgGroup: this.serverURL + "v1/cfgGroup/",
  };
  groupServicesURLs = {
    getGroups: this.serverURL + "v1/group/",
    postGroup: this.serverURL + "v1/group",
    editGroup: this.serverURL + "v1/group",
    getGroupsByType: this.serverURL + "v1/group",
  };

  cfgOneStepServicesURLs = {
    getAllCfgOneStep: this.serverURL + "cfgOneStep/",
    postCfgOneStep: this.serverURL + "cfgOneStep",
    editCfgOneStep: this.serverURL + "cfgOneStep",
    getCfgOneStep: this.serverURL + "cfgOneStep/",
  };

  userServicesURLs = {
    getUsers: this.serverURL + "v1/user/",
    postUser: this.serverURL + "v1/user",
    editUser: this.serverURL + "v1/user",
    assignUser: this.serverURL + "v1/user/assign",
    changePassword: this.serverURL + "v1/user/changePassword",
    resetPassword: this.serverURL + "v1/user/resetPW",
    resetPasswordForForget: this.serverURL + "v1/user/resetPassword",

    getAllAgentStatus: this.serverURL + "v1/user/getAllAgentStatus",
    changeAgentState: this.serverURL + "v1/user/changeAgentState",
    getAgentChangeStateForAgent:
      this.serverURL + "v1/user/getAllAgentChangeStatusForAgent",
      getAgentChangeStateForAgentByDate:
      this.serverURL + "v1/user/getAllAgentChangeStatusForAgentByDate",
    getAgentChangeStateForAccount:
      this.serverURL + "v1/user/getAllAgentChangeStatusForAccount",
      getAgentChangeStateForAccountByDate:
      this.serverURL + "v1/user/getAllAgentChangeStatusForAccountByDate",
    restoreAgentChangeState:
      this.serverURL + "v1/user/getAllAgentChangeStatusForAccountRestore",
    updateProfile: this.serverURL + "v1/user/updateProfile",
    getUserGroup: this.serverURL + "v1/user/",
    getUserByType: this.serverURL + "v1/user/byAccountId/userType/",
    getUsersGroups: this.serverURL + "v1/user/getAllUsersGroups",
    validateUserNumber: this.serverURL + "v1/user/validateUserNumber/",
  };

  customerServiceURLS = {
    getCustomers: this.serverURL + "v1/customer/",
    getAllCustomers: this.serverURL + "v1/customer/allforTickets",
    postCustomer: this.serverURL + "v1/customer",
    editCustomer: this.serverURL + "v1/customer",
    getCustomersByUserId: this.serverURL + "v1/customer/userId/",
    getCustomersById: this.serverURL + "v1/customer/customerId/",
    getAllCustomerSegments:
      this.serverURL + "v1/customer/getAllCustomerSegment",
  };

  ticketServiceURLS = {
    getTickets: this.serverURL + "ticket/",
    postTicket: this.serverURL + "ticket",
    getCustomerTickets: this.serverURL + "ticket/customer/",
    editPriority: this.serverURL + "ticket/changePriority",
    editStatus: this.serverURL + "ticket/changeStatus",
    editSubject: this.serverURL + "ticket/changeSubject",
    editAssignedTo: this.serverURL + "ticket/changeAssignedTo",
    editDueDate: this.serverURL + "ticket/changeDueDate",
    getComments: this.serverURL + "ticket/comments/",
    postComment: this.serverURL + "ticket/comments",
    editComment: this.serverURL + "ticket/comments",
    getTicketTracking: this.serverURL + "ticket/tracking/",
    postTicketTracking: this.serverURL + "ticket/tracking",
  };

  ticketCategoryServiceURLS = {
    getTicketCategory: this.serverURL + "ticket/categories/",
    postTicketCategory: this.serverURL + "ticket/categories",
    editTicketCategory: this.serverURL + "ticket/categories",
    getTicketCategorysById:
      this.serverURL + "ticket/categories/ticketCategoryId/",
    getAllTicketCategorySegments:
      this.serverURL + "ticket/categories/getAllTicketCategoryStatus",
  };
  loginServicesURLs = {
    login: this.serverURL + "v1/authenticate/login",
    verifyMFA: this.serverURL + "v1/authenticate/verifyMFA",
  };
  logoutServicesURLs = {
    logout: this.serverURL + "v1/authenticate/logout",
  };

  systemConfigServicesURLs = {
    getSystemConfigs: this.serverURL + "cfgSystem/",
    editSystemConfigs: this.serverURL + "cfgSystem",
    postSystemConfigs: this.serverURL + "cfgSystem",
  };
  fileServicesURLs = {
    uploadPrompt: this.serverURL + "v1/file/uploadPrompt",
    uploadCallFlow: this.serverURL + "v1/file/uploadCallFlow",
    uploadDevelopedCallFlow: this.serverURL + "v1/file/uploadDevelopedCallFlow",
    editDevelopedCallFlow: this.serverURL + "v1/file/editDevelopedCallFlow",
    uploadProfileImg: this.serverURL + "v1/file/uploadProfileImg",
    uploadMsisdnFile: this.serverURL + "v1/file/uploadMsisdnFile",
    getPrompts: this.serverURL + "v1/file/getPrompts",
    getCallFlows: this.serverURL + "v1/file/getCallFlows",
    downloadPrompt: this.serverURL + "v1/file/downloadPrompt/fileId/",
    downloadCallFlow: this.serverURL + "v1/file/downloadCallFlow/fileId/",
    downloadDevelopedCallFlow:
      this.serverURL + "v1/file/downloadDevelopedCallFlow/fileId/",
    downloadCallRecord: this.serverURL + "v1/file/downloadCallRecord/fileId/",
    assignCallFlow: this.serverURL + "v1/cfgGroup/assign/callFlow",
    deletePrompt: this.serverURL + "v1/file/deletePrompt/fileId/",
    deleteCallFlow: this.serverURL + "v1/file/deleteCallFlow/fileId/",
    downloadMsisdnTemp: this.serverURL + "v1/file/downloadTemplate/fileId/",
    getUserImg: this.serverURL + "v1/file/getUserImg/",
    deleteUserImg: this.serverURL + "v1/file/deleteUserImg/",
    downloadVoiceMail: this.serverURL + "v1/file/downloadVoiceMail/fileId/",
    downloadBackUpFile: this.serverURL + "v1/file/downloadBackupFile",
    downloadVoiceMailFiles: this.serverURL + "v1/file/downloadVoiceMailFiles",
    downloadCdrFiles: this.serverURL + "v1/file/downloadCdrFiles",
  };
  packageAndPrivilegeServicesURLs = {
    getPackages: this.serverURL + "v1/privilege/listPackages",
    createPackage: this.serverURL + "v1/privilege/createPackage",
    editPackage: this.serverURL + "v1/privilege/editPackage",
    deletePackage: this.serverURL + "v1/privilege/deletePackage/",
    getPrivileges: this.serverURL + "v1/privilege/listPrivileges",
    getPackagePrivileges:
      this.serverURL + "v1/privilege/listPackagePrivileges/",
    addPackagePrivileges: this.serverURL + "v1/privilege/addPackagePrivileges",
  };
  cfgUserServicesURLs = {
    editCfgUser: this.serverURL + "v1/cfgUser/",
    getCfgUser: this.serverURL + "v1/cfgUser/byAccountId/",
    getAvailability: this.serverURL + "v1/cfgAccount/available/key",
  };
  actuatorURLs = {
    editLoggingFile: this.serverURL + "actuator/loggers/com.mokalmat.vbp",
  };

  RestoreURLS = {
    UsersAndGroupsConfigRestore:
      this.serverURL + "v1/configurations/restoreUsersAndGroups",
    UsersAndGroupsConfigBackup:
      this.serverURL + "v1/configurations/downloadBackupFile",
    crmConfigRestore: this.serverURL + "v1/configurations/restoreCrm",
    CrmConfigBackup: this.serverURL + "v1/configurations/downloadCrmBackupFile",

    promptsConfigBackup:
      this.serverURL + "v1/configurations/downloadPromptsBatch",
    promptsConfigRestore: this.serverURL + "v1/configurations/restorePrompts",
    callFlowsConfigBackup:
      this.serverURL + "v1/configurations/downloadCallFlowsBatch",
    callFlowsConfigRestore:
      this.serverURL + "v1/configurations/restoreCallFlows",
    getAccountConfigurationsCount:
      this.serverURL + "v1/configurations/accountConfigurationsCount",
  };
  liveCallServiceURLs = {
    getLiveCallsFromToStartDate: this.serverURL + "liveCall/",
    searchLiveCalls: this.serverURL + "liveCall/search/",
  };

  accoutRout = "configuration/account";

  getCurrentUser() {
    return "admin";
  }

  getCurrentTimeStamp() {
    return "2018-11-12 23:06:16.684647+02";
  }

  getIntialDate() {
    return new Date(1980, 1, 1);
  }

  removeDateTimeZone(fullDate) {
    if (fullDate) {
      let result = fullDate.split(".");
      return result[0];
    }
  }
}
